export class Policy {
  constructor(user, record) {
    this.user = user;
    this.record = record;
  }
  can(action) {
    const classMethod = this[action];
    if (classMethod instanceof Function) {
      return classMethod.bind(this)(this.user, this.record);
    }
    return false;
  }
}